import React from 'react';
import AuthService from './authService.js';

class AssignmentStatusService extends React.Component {
  // The status list is static lookup data, but GetName is called once per rendered grid row / detail field —
  // fetch it once per session and share the promise so concurrent rows don't each download the whole list.
  static statusListPromise = null;

  static GetName(id) {
    if (!AssignmentStatusService.statusListPromise) {
      const authService = AuthService.getInstance();
      const url = 'api/AssignmentStatus/GetList/?clearCache=false';
      AssignmentStatusService.statusListPromise = authService.CallBackendFunction(url).catch((error) => {
        // Evict on failure (e.g. a transient 429) so the next caller retries instead of caching the rejection
        AssignmentStatusService.statusListPromise = null;
        throw error;
      });
    }
    return AssignmentStatusService.statusListPromise.then((statusList) => statusList.find((l) => l.lgsId === id));
  }
}

export default AssignmentStatusService;
